/* eslint-disable react-hooks/exhaustive-deps */
import { unwrapResult } from "@reduxjs/toolkit";
import { Button, Radio, Tag } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../app/store";
import { SupervisorSelectModal } from "../../components/modal/SupervisorSelectModal";
import { MultipleYLine } from "../../components/MultipleYLine";
import styles from "./HealthPrisonAnaylse.module.css";
import { getHealthPrisonContrastData } from "./HealthPrisonAnaylseSilce";
import { Skeleton } from "./Skeleton";

export const HealthProportionContrast = () => {
  const [time, setTime] = useState(2);

  const [selectData, setSelectData] = useState<any>([]);

  const [medicalData, setMedicalData] = useState<any>([]);

  const [cautionData, setCautionData] = useState<any>([]);

  const [handleData, setHandleData] = useState<any>([]);

  const [isModalVisible, setIsModalVisible] = useState(false);

  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (selectData.length) {
      dispatch(
        getHealthPrisonContrastData({
          scope: time,
          osId: selectData[0]?.osId || 0,
        })
      )
        .then(unwrapResult)
        .then((res) => {
          setMedicalData(
            res.map((v) => {
              return v.medicalTotal;
            })
          );
          setCautionData(
            res.map((v) => {
              return v.cautionTotal;
            })
          );
          setHandleData(
            res.map((v) => {
              return v.handleTotal;
            })
          );
        });
    }
  }, [time, selectData]);

  return (
    <div className={styles.contranst}>
      <div className={styles.choise}>
        <Button type='primary' onClick={() => setIsModalVisible(true)}>
          选择卫健委(局)
        </Button>
        {selectData[0]?.osName ? (
          <Tag
            closable
            color='processing'
            onClose={(e) => {
              setSelectData([])
            }}
            style={{ margin: '10px' }}
          >
            {selectData[0]?.osName}
          </Tag>
        ) : (
          <></>
        )}
      </div>
      <div className={styles.selects}>
        <h3>各卫健委(局)监管数据变化分析</h3>
        <Radio.Group
          defaultValue={time}
          onChange={(e: any) => {
            setTime(e.target.value)
          }}
          optionType='button'
          buttonStyle='solid'
          style={{ float: 'right' }}
        >
          <Radio.Button value={0}>近七天</Radio.Button>
          <Radio.Button value={1}>近30天</Radio.Button>
          <Radio.Button value={2}>近一年</Radio.Button>
        </Radio.Group>
      </div>
      <div className={styles.content}>
        {selectData.length === 0 ? (
          <Skeleton
            isSelect={() => {
              setIsModalVisible(true)
            }}
          />
        ) : (
          <MultipleYLine
            timeQuantum={time}
            firstData={medicalData}
            secondData={cautionData}
            thirdData={handleData}
            style={{ height: '100%' }}
          />
        )}
      </div>
      <SupervisorSelectModal
        mode='radio'
        initialValue={selectData}
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        onOk={() => setIsModalVisible(false)}
        onChange={(s) => setSelectData(s)}
      />
    </div>
  )
};
